import { useState } from "react";
import { useRouteError } from "react-router-dom";
import { removeAuthCompletely } from "./core/_axios";

export default function ErrorPage() {
    const error = useRouteError();
    const [copied, setCopied] = useState(false);
    console.error(error);

    const errorReport = [
        `Error: ${error?.statusText || error?.message || 'Unknown error'}`,
        `URL: ${window.location.href}`,
        `Time: ${new Date().toISOString()}`,
        `UserAgent: ${navigator.userAgent}`,
        '',
        '--- Stack Trace ---',
        error?.stack || 'No stack trace available',
    ].join('\n');

    const handleLogout = () => {
        removeAuthCompletely();
        window.location.href = '/auth/login';
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(errorReport).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="card max-w-[600px] w-full m-8">
                <div className="card-body flex flex-col gap-5 p-10">
                    <div className="text-center">
                        <h2 className="text-xl font-semibold text-gray-900">
                            Something went wrong
                        </h2>
                        <p className="text-sm text-gray-600 mt-2">
                            An unexpected error occurred. Please copy the error details below and send them to support, then try reloading or signing out.
                        </p>
                    </div>
                    <div className="relative">
                        <pre className="text-xs text-gray-700 bg-gray-100 p-4 rounded-lg overflow-auto max-h-[300px] whitespace-pre-wrap break-all font-mono select-all">
                            {errorReport}
                        </pre>
                        <button
                            onClick={handleCopy}
                            className="absolute top-2 right-2 btn btn-xs btn-light"
                        >
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                    </div>
                    <div className="flex gap-3 justify-center">
                        <button
                            onClick={() => window.location.reload()}
                            className="btn btn-primary"
                        >
                            Reload Page
                        </button>
                        <button
                            onClick={handleLogout}
                            className="btn btn-light"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
